export default __webpack_public_path__ + "static/media/img3.698df6f2.png";